<template>
  <div class="global-container">
      <ACHeader></ACHeader>
        <router-view
          :models="models"
        ></router-view>
      <ACFooter></ACFooter>
  </div>  
  
</template>

<script>
import ACHeader from './components/Header.vue'
import ACFooter from './components/Footer.vue'
import models from "./models"


export default {
  name: 'App',
  data(){
    return {
      models: models,
      isNotificationDisplayed: true
    }
  },

  metaInfo() { 
    return{
      title: this.$t('metaDesc'),
    }
  },
  

  computed:{
    isSafari() {
      const userAgentString =  navigator.userAgent
      let safariAgent = userAgentString.indexOf("Safari") > -1;
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      if((chromeAgent) && (safariAgent)) {
        safariAgent = false;
      }

      return safariAgent
    },

    isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    },
  },

  methods: {
    closeNotification(){
      this.isNotificationDisplayed = false
    }
  },


  components: {
      ACHeader: ACHeader,
      ACFooter: ACFooter,
  },

}


</script>

<style lang="scss">
  
  @import "styles/core/variables.scss";
  @import "styles/core/resets.scss";
  @import "styles/global/background.scss";
  @import "styles/global/helpers.scss";
  @import "styles/core/typography.scss";



</style>
